















































import collect from 'collect.js';
import { helpers, required } from '@vuelidate/validators';
import { useVuelidate } from '@vuelidate/core';

export default {
    name: 'PublishJobModal',

    props: {
        job: {
            required: true,
            type: Object,
        },
    },

    setup(props, context) {
        const { $dayjs, $store } = useNuxtApp();

        const hasSufficientTokens = ref<boolean>(true);
        const showTokenPackageDialog = ref(false);

        const billingIsEnabled = computed(() => process.env.BILLING_ENABLED === 'true');
        const job = computed(() => $store.getters['jobs/single/getSingleJob']);
        const error = ref<string | null>(null);
        const isBursary = computed(() => props.job.job_type === 'Bursary');
        const modelType = computed(() => (isBursary.value ? 'Bursary' : 'Job Post'));
        const infoMessage = computed(() => {
            return isBursary.value ? 'Bursaries will be published for 60 days by default' : 'Jobs will be published for 30 days by default';
        });

        const minDate = $dayjs().format('YYYY-MM-DD');
        const maxDate = $dayjs()
            .add(isBursary.value ? 60 : 30, 'days')
            .format('YYYY-MM-DD');

        const form = reactive({
            expiry_date: maxDate,
            university_scope: null,
        });

        const rules = computed(() => ({
            expiry_date: {
                required: helpers.withMessage('The Expiry Date field is required.', required),
                $lazy: true,
            },
            university_scope: {
                required: helpers.withMessage('The University Scope field is required.', required),
                $lazy: true,
            },
        }));

        const v$ = useVuelidate(rules, form);

        /**
         * Get the available job types that can be published
         * from the company's available token records and
         * check if it includes the specified job's type.
         */
        const checkTokenBalance = () => {
            $store
                .dispatch('tokenRecords/getRecords')
                .then((result) => {
                    hasSufficientTokens.value = collect(result)
                        .map((record) => record.job_types)
                        .filter()
                        .flatten()
                        .unique()
                        .all()
                        .includes(job.value.job_type);
                })
                .catch((error) => {
                    console.log(error);
                });
        };

        const submit = async () => {
            await v$.value.$validate();

            if (v$.value.$invalid) return;

            $store
                .dispatch('jobs/draft/publishJobPost', {
                    job_uuid: props.job.uuid,
                    expiry_date: form.expiry_date,
                    university_scope: form.university_scope,
                })
                .then(() => {
                    context.emit('submitted');
                })
                .catch((err) => {
                    error.value = err.response.data.message;
                });
        };

        checkTokenBalance();

        return {
            billingIsEnabled,
            error,
            form,
            modelType,
            hasSufficientTokens,
            infoMessage,
            isBursary,
            minDate,
            maxDate,
            submit,
            showTokenPackageDialog,
            v$,
        };
    },
};
